'use client'

import Image from 'next/image'
import { useEffect, useRef } from 'react'
import { cn, setButtonObject, setImageObject } from '@/lib/utils'
import { Headline } from '@/components/ui/headline'
import { buttonVariants } from '@/components/ui/button'
import {MainMenuItemModel} from "@/components/custom/header/mainmenu/mainMenuItem";
import Link from "next/link";

const subMenuTeaserClasses = {
    default:
        'menu-list flex flex-col transition-all duration-300 ease-in-out invisible -translate-x-3 opacity-0 pl-6 lg:pl-12 lg:py-12 dotted-divider-left lg:col-span-3',
    active: 'visible translate-x-0 opacity-100'
}

interface SubMenuTeaserProps {
    item: MainMenuItemModel | null | undefined,
    locale: string;
    level: number;
    setListHeights: ({}: any) => void;
}

const SubMenuTeaser = ({ item, locale, level, setListHeights } : SubMenuTeaserProps) => {
    const teaserRef = useRef(null)

    useEffect(() => {
        // @ts-ignore
        const newHeight = { [level]: teaserRef.current.getBoundingClientRect().height }
        setListHeights((oldObj: any) => ({
            ...oldObj,
            ...newHeight
        }))
    }, [item, level, setListHeights])

    if (item) {
        const image = setImageObject(item.teaser?.image)
        const content = item.teaser?.content?.teaser || null
        const button = setButtonObject(item.teaser?.link, locale)

        return (
            <div ref={teaserRef} className={cn(subMenuTeaserClasses['default'], item?.teaser && subMenuTeaserClasses['active'])} data-level={5}>
                {item?.teaser && (
                    <>
                        {image && (
                            <Image className='max-h-[275px] w-full' src={image.src} alt={image.alt} width={image.width} height={image.height} priority={true} />
                        )}
                        <div className='content'>
                            <Headline variant='h3' size='lg' className='mt-4 text-primary'>
                                {item.teaser?.headline}
                            </Headline>
                            {content && <p className='mt-2 text-sm'>{content}</p>}
                            {button && (
                                <p className='mt-4'>
                                    <Link href={button.url} className={buttonVariants({ variant: 'outline', size: 'lg' })} locale={locale}>
                                        {'Missing'}
                                    </Link>
                                </p>
                            )}
                        </div>
                    </>
                )}
            </div>
        )
    }
    if (!item) {
        return (
            <div
                ref={teaserRef}
                className={cn(subMenuTeaserClasses['default'], teaserRef && subMenuTeaserClasses['active'])}
                data-level={5}
            ></div>
        )
    }
}

export { SubMenuTeaser }
